<style lang="less" scoped>
  .v-divider {
    margin: 10px 0;
  }
</style>

<template>
  <v-card
    class="card"
    outlined
  >
    <v-card-title>
      职能: {{ customer_function }}
      <space />
    </v-card-title>
    <v-card-text>
      人员属性: {{ customer_types_f }}
      <v-divider />
      团队:
      <v-chip
        v-for="id in mapping.team_ids"
        :key="`team_${id}`"
        outlined
        small
        style="margin-right: 4px"
      >
        <TeamName :id="id" />
      </v-chip>
      <v-divider />
      岗位:
      <v-chip
        v-for="id in mapping.job_ids"
        :key="`job_${id}`"
        outlined
        small
        style="margin-right: 4px"
      >
        <JobName :id="id" />
      </v-chip>
      <v-divider />
      <div
        v-for="wage in wage_list"
        :key="wage.key"
      >
        <span>{{ wage.label }}: </span>
        <span>{{ titleNamesByTitleMapping(mapping[wage.key]) }}</span>
      </div>
    </v-card-text>

    <v-card-actions>
      <!--<v-btn-->
      <!--  icon-->
      <!--  @click="toggleExpand"-->
      <!--&gt;-->
      <!--  <v-icon>{{ expand ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>-->
      <!--</v-btn>-->
      <v-spacer />
      <v-btn
        color="primary"
        text
        @click="emitEditEvent"
      >
        <v-icon>mdi-pencil-outline</v-icon>
        修改
      </v-btn>
    </v-card-actions>

    <!--<v-expand-transition>-->
    <!--  -->
    <!--</v-expand-transition>-->
  </v-card>
</template>

<script>
  import {mapGetters} from "vuex";
  import WAGE_LIST from '../constants/wage_list';
  import TitleMappingUtil from '../mixins/title_mapping_util';
  import TeamName from '../../team/components/name';
  import JobName from '../../job/components/name';

  export default {
    components: { TeamName, JobName },
    mixins: [TitleMappingUtil],
    props: {
      mapping: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        expand: false,
        wage_list: WAGE_LIST,
      }
    },
    computed: {
      ...mapGetters('async', [
        'teams_hash',
        'jobs',
        'customer_functions_hash',
        'expense_natures_hash',
        'customer_types_hash',
        'item_types_hash',
        'fund_usages_hash',
        'title_mappings',
        'analysis_titles_hash',
        'account_titles_hash',
      ]),
      customer_function() {
        const item = this.customer_functions_hash[this.mapping.customer_function_id];
        return item ? item.name : '未定义职能';
      },
      customer_types_f() {
        const item = this.customer_types_hash[this.mapping.customer_type]
        return item ? item.label : '未定义职能';
      }
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      emitEditEvent() {
        this.$emit('edit', this.mapping);
      },
      toggleExpand() {
        this.expand = !this.expand;
      },
    }
  }
</script>
